import React, { useEffect, useMemo, useState } from "react";
import { StyledTablePage } from "../../styled-components/StyledTablePage.style";
import Flex from '@react-css/flex';
import Modal from 'react-modal';
import { StyledForm } from "../../styled-components/StyledForm.style";
import { StyledCardTimelineSheet } from "../../styled-components/StyledCardTimelineSheet.style";
import moment from "moment";

export const ModalTimeline = (
    { 
        isOpen,
        setIsOpen,
        onAfterOpen, 
        onRequestClose,
        idTimesheet,
        timelineInfs,
        porEtapaAprovacao,
        finalizacaoTS,
        nomeEtapaAtual,
        nfDataFaturamento,
        nfDataRecebimento
    }
    ) => {
    const style = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: "0px",
            overflowY: 'auto',
            minHeight: '45%',
            maxHeight: '90%',
            maxWidth: '100%'
        },
        overlay: {
            zIndex: 9999
        }
    };

    const [informacoes, setInformacoes] = useState([]);

    const ordem = {
        'Revisão Gestão': 0, 
        'Revisão Administrativo': 1, 
        'Aprovação Diretoria': 2,
        'Data de abertura do TS': 3,
        'Liberação para o Faturamento': 4
    }

    const isValidDate = (val) => val && val.trim() !== "" && val !== "null";

    useEffect(() => {
        if(isOpen) {
            let timelines = [...timelineInfs]
            let dataFaturamentoMoment = null;
            let dataRecebimentoMoment = null;
            let dataAprovacaoDiretoria = null;
            let dataAprovacaoCliente = null;

            if(finalizacaoTS) {
                timelines.push({
                    label: "Data da finalização do TS",
                    value: moment(finalizacaoTS || '').isValid() ? moment(finalizacaoTS).format('DD/MM/YYYY') : finalizacaoTS
                })
            }

            console.log(timelines);

            timelines.map(tim => {
                var dias = 0
                if(tim.label == "Data do Sinistro") {
                    dias = null
                }
                if(tim.label == "Data de abertura do Sinistro") {
                    if(timelines[0].value != "Não informado")
                        dias = moment(tim.value, 'DD/MM/YYYY').startOf('day').diff(moment(timelines[0].value, 'DD/MM/YYYY').startOf('day'), 'days')
                    else
                        dias = null
                }
                if(tim.label == "Data de abertura do TS") {
                    if(timelines.length == 3) {
                        //tim['hiddenDate'] = true
                        dias = moment(new Date, 'DD/MM/YYYY').startOf('day').diff(moment(tim.value, 'DD/MM/YYYY').startOf('day'), 'days')
                    }
                    else {
                        dias = moment(tim.value, 'DD/MM/YYYY').startOf('day').diff(moment(timelines[1].value, 'DD/MM/YYYY').startOf('day'), 'days')
                    }
                }
                if (tim.label == "Data da finalização do TS" && timelines.length >= 3) {
                    const ref = timelines[2];
                    if (ref && ref.value) {
                        if (finalizacaoTS == "Não informado") {
                            tim['hiddenDate'] = true
                        } else {
                            dias = moment(tim.value, 'DD/MM/YYYY').startOf('day').diff(moment(ref.value, 'DD/MM/YYYY').startOf('day'), 'days');                            
                        }
                    }
                }
        
                tim['dias'] = dias
            })
            
            if(porEtapaAprovacao) {
                let etapas = [...porEtapaAprovacao]
                etapas.forEach((etapa, index) => {
                    var dias = null
                    if(ordem[nomeEtapaAtual] == undefined || (ordem[nomeEtapaAtual] >= ordem[etapa.nomeEtapa])) {
                        if(etapa.nomeEtapa == 'Revisão Gestão') {
                            const ref = timelines[3];
                            if (ref && ref.value) {
                                dias = moment(etapa.dataCriacao).startOf('day')
                                    .diff(moment(ref.value, 'DD/MM/YYYY').startOf('day'), 'days');
                            }
                        }
                        if(etapa.nomeEtapa == 'Revisão Administrativo') {
                            dias = moment(etapa.dataCriacao).startOf('day').startOf('day').diff(moment(etapas[1].dataCriacao).startOf('day'), 'days')
                        }
                        if(etapa.nomeEtapa == 'Aprovação Diretoria') {
                            dataAprovacaoDiretoria = moment(etapa.dataCriacao).startOf('day');
                            dias = moment(etapa.dataCriacao).startOf('day').startOf('day').diff(moment(etapas[2].dataCriacao).startOf('day'), 'days')
                        }
                        if(etapa.nomeEtapa == 'Liberação para o Faturamento') {
                            dataAprovacaoCliente = moment(etapa.dataCriacao).startOf('day');
                            dias = moment(etapa.dataCriacao).startOf('day').startOf('day').diff(moment(etapas[3].dataCriacao).startOf('day'), 'days')
                        }

                        if(ordem[nomeEtapaAtual] == ordem[etapa.nomeEtapa]) {
                            dias = moment(new Date).startOf('day').startOf('day').diff(moment(etapa.dataCriacao).startOf('day'), 'days')
                            etapa.hiddenDate = true
                        }
                        else {
                            etapa.hiddenDate = false
                        }
                    
                        timelines.push({
                            label: etapa.nomeEtapa == 'Liberação para o Faturamento' ? "Aprovação Cliente" : etapa.nomeEtapa,
                            value: moment(etapa.dataCriacao).format('DD/MM/YYYY'),
                            dias: dias,
                            hiddenDate: ordem[nomeEtapaAtual] == ordem[etapa.nomeEtapa]
                        })
                    }
                });
            }

            if(isValidDate(nfDataFaturamento)) {
                let diasDesdeAprovacao = null;
                dataFaturamentoMoment = moment(nfDataFaturamento, 'YYYY-MM-DD').startOf('day');

                if (dataAprovacaoCliente) {
                    diasDesdeAprovacao = dataFaturamentoMoment.diff(dataAprovacaoCliente, 'days');
                }

                if (dataAprovacaoDiretoria && !dataAprovacaoCliente) {
                    diasDesdeAprovacao = dataFaturamentoMoment.diff(dataAprovacaoDiretoria, 'days');
                }

                timelines.push({
                    label: "Data Faturamento",
                    value: moment(nfDataFaturamento).format('DD/MM/YYYY'),
                    dias: diasDesdeAprovacao
                })
            }

            if(isValidDate(nfDataRecebimento)) {
                let diasDesdeFaturamento = null;
                dataRecebimentoMoment = moment(nfDataRecebimento, 'YYYY-MM-DD').startOf('day');

                if (dataFaturamentoMoment) {
                    diasDesdeFaturamento = dataRecebimentoMoment.diff(dataFaturamentoMoment, 'days');
                }

                timelines.push({
                    label: "Data Recebimento",
                    value: moment(nfDataRecebimento).format('DD/MM/YYYY'),
                    dias: diasDesdeFaturamento
                })
            }

            setInformacoes(timelines)            
        }
    }, [idTimesheet, isOpen])

    return (
        <Modal
            isOpen={isOpen}
            onAfterOpen={onAfterOpen}
            onRequestClose={onRequestClose}
            contentLabel="Histórico"
            style={style}
            ariaHideApp={false}
            shouldCloseOnOverlayClick={false}
        >
            <StyledForm>
                <p className="modal-close" onClick={onRequestClose}>X</p>
            </StyledForm>
            <Flex>
                <StyledForm style={{ width: "100%" }}>
                    <StyledCardTimelineSheet>
                        <div className="timeline">
                            <div className="box">
                                <div className="container">
                                    <div className="lines">
                                        { informacoes.map(item => {
                                            return (
                                                <>
                                                    <div className="dot dot-fill"></div>
                                                    <div className="line line-fill"></div>
                                                </>
                                            )
                                        })}
                                    </div>
                                    
                                    <div className="cards">
                                        { informacoes.map(item => {
                                            return (
                                                <div className="card">
                                                    <h4>{item.label}</h4>
                                                    <p style={{ alignSelf: `${item.hiddenDate ? "end" : ""}` }}>
                                                        {!item.hiddenDate && item.value} 
                                                        {
                                                            item.dias != null && (<span className="badge rounded-pill bg-primary">+{item.dias} D</span>)
                                                        }
                                                </p>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </StyledCardTimelineSheet>
                </StyledForm>
            </Flex>
        </Modal>
    );
};